import { useMemo } from 'react'
import { DiagnosticFinding, Severity } from '../types'

export interface DiagnosticsSummary {
  total: number
  high: number
  warning: number
  info: number
  maxSeverity: Severity | null
}

export const useDiagnosticsSummary = (
  findings: DiagnosticFinding[],
): DiagnosticsSummary => {
  return useMemo(() => {
    const high = findings.filter(f => f.severity === 'high').length
    const warning = findings.filter(f => f.severity === 'warning').length
    const info = findings.filter(f => f.severity === 'info').length

    let maxSeverity: Severity | null = null
    if (high > 0) {
      maxSeverity = 'high'
    } else if (warning > 0) {
      maxSeverity = 'warning'
    } else if (info > 0) {
      maxSeverity = 'info'
    }

    return { total: findings.length, high, warning, info, maxSeverity }
  }, [findings])
}
